export default __webpack_public_path__ + "static/media/5t.05826c31.jpg";